/*
  References

  "hero": {
    "width": 1360,
    "height": 765
  },
  "mainscreen": {
    "width": 900,
    "height": 510
  },
  "cover": {
    "width": 445,
    "height": 250
  },
  "xcover": {
    "width": 300,
    "height": 170
  }
*/

export const getThumbnail = (video, size = 'cover') => {
  if (!video || !video.media) return

  const coverImg = video.media[0]
  const coverImgOrder0 = video.media.find(item => item.order === 0)
  const coverImgOrder1 = video.media.find(item => item.order === 1)

  const res = coverImg || coverImgOrder1 || coverImgOrder0;

  return res?.sizes[size]
}